module.exports = __webpack_public_path__ + "847127fefa598c5e41f1c3377c10c1fe.fbx";